import { render, staticRenderFns } from "./IconContactLight.vue?vue&type=template&id=83c555ec&"
import script from "./IconContactLight.vue?vue&type=script&lang=js&"
export * from "./IconContactLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports